import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { library } from '@fortawesome/fontawesome-svg-core'
import moment from 'moment-jalaali'
import firebase from 'firebase/app'
import 'firebase/messaging'
import './registerServiceWorker'
import {
    faHome,
    faBook,
    faEnvelope,
    faAddressCard,
    faComment,
    faUserPlus,
    faCreditCard,
    faHistory,
    faTasks,
    faFile,
    faChartArea,
    faIdCard,
    faPlane,
    faSave,
    faCar,
    faTrain,
    faLink,
    faTimes,
    faCalculator,
    faUniversity,
    faFileExcel,
    faQuestionCircle,
    faAngleLeft,
    faAngleDown,
    faUsers,
    faUserCircle,
    faCheckDouble,
    faSearch,
    faCalendarAlt,
    faClock,
    faCheck,
    faBriefcase,
    faExclamation,
    faHashtag,
    faGlobe,
    faAngleRight,
    faAngleDoubleRight,
    faMoneyBill,
    faUser,
    faDownload,
    faSignal,
    faCertificate,
    faHeart,
    faChalkboardTeacher,
    faFileSignature,
    faUserClock,
    faTimesCircle,
    faExchangeAlt,
    faChalkboard,
    faFileAlt,
    faHandPaper,
    faBuilding,
    faArrowsAltH,
    faMicrophone,
    faPoll,
    faCalendarTimes,
    faComments,
    faQuran,
    faPhone,
    faUserCog,
    faBookOpen,
    faFileWord,
    faCode,
    faLightbulb,
    faTrophy,
    faMosque,
    faNewspaper,
    faMapMarkedAlt,
    faCity,
    faChevronLeft,
    faChevronRight,
    faWarehouse,
    faUtensils,
    faTh, faSchool

} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHome, faBook, faEnvelope, faAddressCard, faComment, faUserPlus, faCreditCard,
    faHistory, faTasks, faFile, faChartArea, faIdCard, faPlane, faSave,
    faCar, faTrain, faLink, faTimes, faCalculator, faFileExcel, faUniversity, faQuestionCircle, faAngleLeft, faAngleDown, faUsers, faUserCircle, faCheckDouble,
    faSearch, faCalendarAlt, faClock, faCheck, faBriefcase, faExclamation, faHashtag, faGlobe, faAngleRight, faAngleDoubleRight, faBuilding, faMoneyBill, faUser,
    faDownload, faSignal, faCalendarCheck, faCertificate, faHeart, faChalkboardTeacher, faFileSignature, faUserClock,
    faTimesCircle, faExchangeAlt, faChalkboard, faMoneyBill, faFileAlt, faHandPaper, faArrowsAltH, faMicrophone, faClock, faChartBar, faPoll, faCalendarTimes,
    faComments, faQuran, faPhone, faUserCog, faBookOpen, faFileWord, faCode, faLightbulb, faTrophy, faMosque, faNewspaper, faMapMarkedAlt, faCity, faChevronLeft, faChevronRight, faWarehouse, faUtensils, faTh, faSchool)

Vue.component('font-awesome-icon', FontAwesomeIcon)
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import JsonExcel from "vue-json-excel";
import { faCalendarCheck, faChartBar } from '@fortawesome/free-regular-svg-icons';
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.component("export-excel", JsonExcel);
Vue.config.productionTip = false

window.popStateDetected = false
window.addEventListener('popstate', () => {
    window.popStateDetected = true
})
Vue.mixin({
    methods: {
        toJalaliDateTime: dateTime => moment(dateTime, 'D-M-YYYY HH:mm:ss').format('jYYYY/jM/jD HH:mm:ss'),
        toJalaliTimestamp: timestamp => moment(timestamp).format('jYYYY/jM/jD'),
        numberWithCommas: x => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

    }
})






new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app')